/**
 * Hashing compartido.
 *
 * Extraído de `stores/library.ts` para que la deduplicación por `contentHash`
 * sea reutilizable por otras rutas de importación (URL, OPDS, backup) sin
 * duplicar la lógica.
 */

/**
 * Calcula el hash SHA-256 de un Blob como string hex minúsculo.
 *
 * Usa `crypto.subtle` (disponible solo en contextos seguros: https o
 * localhost). Es determinista y idempotente, por lo que sirve como clave
 * de deduplicación de EPUBs: el mismo archivo siempre produce el mismo hash.
 */
export async function sha256Hex(blob: Blob): Promise<string> {
  const buffer = await blob.arrayBuffer()
  const digest = await crypto.subtle.digest('SHA-256', buffer)
  const bytes = new Uint8Array(digest)
  let hex = ''
  for (const b of bytes) hex += b.toString(16).padStart(2, '0')
  return hex
}
